import { useEffect, useState } from 'react'
import { destinoAoCriarProduto } from '../../produtos/voltarParaTabela'
import { voltarDoCorrigir, faltasNoCadastro } from '../../produtos/corrigirProduto'
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { useLiveQuery } from 'dexie-react-hooks'
import { banco } from '../../db/banco'
import { buscarVivo } from '../../db/registroVivo'
import { novoRegistroBase } from '../../db/tipos'
import type { Preco, Produto, TabelaPreco } from '../../db/tipos'
import { gravarLocalEEnfileirar, apagarLocalEEnfileirar, gravarEmLote } from '../../sync/outbox'
import { useSalvamento } from '../../componentes/useSalvamento'
import { confirmar } from '../../componentes/confirmar'
import { decidirPrecoDoCadastro, dicaDoPreco } from '../../produtos/precoNoCadastro'
import { decidirAvulsoDoCadastro, dicaDoAvulso } from '../../produtos/precoAvulsoDoCadastro'
import { modoInicialDaFicha, botaoDoModo, type ModoDaFicha } from '../../componentes/modoDaFicha'
import { rascunhoDePrecoAoEditar } from '../../produtos/rascunhoDePrecoAoEditar'
import { tabelasVisiveisNaFicha } from '../../produtos/tabelasVisiveisNaFicha'
import { ROTULO_PRECO_AVULSO } from '../../produtos/rotuloDoPreco'
import { acaoDoCard } from '../../produtos/acaoDoCard'
import { registrarGuardaDeSaida } from '../../componentes/guardaDeSaida'
import { sugerirFator } from '../../produtos/sugestaoFator'
import { OPCOES_EMBALAGEM_FECHADA, ehUnidadeSolta, ehValorLegado, valorNoSeletor } from '../../produtos/seletorEmbalagem'
import { avisoDeMinimoAoDefinirFator } from '../../produtos/avisoMinimo'
import { converterPercentualTributo, converterFatorEmbalagem } from '../../importacao/validacao'
import { historicoDoProduto } from '../../produtos/historicoDoProduto'
import CampoMoeda from '../../componentes/CampoMoeda'
import FichaProdutoVendo, { type AbaDaFicha } from './FichaProdutoVendo'
import { abaDoEndereco } from '../../produtos/abaDoEndereco'
import { valoresUsados } from '../../produtos/valoresUsados'
import { origemDoCadastro, tabelaEfetivaDoCadastro } from '../../produtos/origemDoCadastro'
import { codigoRepetido } from '../../produtos/codigoRepetido'
import { gravacoesDeTabelaSoNome } from '../../precos/tabelaNova'

// Marcador do "+ Nova tabela…" na lista -- nunca vira id gravado.
const NOVA_TABELA = '__nova_tabela__'
import Secao from './formulario/Secao'
import CampoLista from './formulario/CampoLista'
import CaixaFoto from './formulario/CaixaFoto'
import BarraSalvar from './formulario/BarraSalvar'
import { IconeCaixa, IconeDocumento, IconeEtiqueta, IconeGrafico, IconeLapis, IconePredio } from './IconesDaFicha'

export default function FormProduto() {
  const { id } = useParams()
  const navegar = useNavigate()
  const { estado: estadoSalvamento, executar } = useSalvamento()
  const ehNovo = id === undefined
  // `null` = procurou e NAO existe (apagado, ou link velho); `undefined` = ainda
  // carregando. Sem o `?? null` os dois chegavam iguais, e um produto apagado
  // ficava em "Carregando…" para sempre (minor 1 da revisao de 23/09).
  const existente = useLiveQuery(
    () => buscarVivo(banco.produtos, id).then((p) => p ?? null),
    [id],
  )
  const representadas = useLiveQuery(
    () => banco.representadas.filter((r) => r.apagado_em === null).sortBy('nome'),
    [],
  )

  // Aberto pelo "+ Produto novo" da tabela: ja vem com a fornecedora dela.
  const [campos, setCampos] = useState({
    representada_id: (ehNovo && new URLSearchParams(window.location.search).get('representada')) || '', codigo: '', descricao: '', unidade: '', categoria: '',
    linha: '', fabricante: '', foto_url: '', estoque: '', observacoes: '',
    ncm: '', ipi_pct: '', icms_pct: '', st_pct: '', pis_cofins_pct: '', unidades_por_embalagem: '',
    ativo: true,
  })

  // ⚠ O preco NAO e campo do produto: mora na tabela `precos`, que amarra
  // tabela de preco + produto + preco. Por isso o bloco abaixo pede DUAS
  // coisas, e nao uma. Ate 16/08/2026 nao havia campo nenhum aqui, e produto
  // cadastrado a mao nascia sem preco em tabela alguma -- ou seja, invendavel.
  // Vindo do "+ Produto novo" da tabela (teste dela 30/09): a tabela ja vem escolhida.
  const [tabelaEscolhida, setTabelaEscolhida] = useState(() => new URLSearchParams(window.location.search).get('tabela') || '')
  // "+ Nova tabela…" (pedido dela 30/09, opcao A): `null` = escolhendo da lista;
  // texto = criando uma tabela com esse nome, que so e gravada no Salvar.
  const [nomeTabelaNova, setNomeTabelaNova] = useState<string | null>(null)
  const [textoPreco, setTextoPreco] = useState('')
  // A regra de quantidade daquele preco. Mora na mesma linha de `precos` que o
  // valor, por isso fica neste bloco e nao entre os campos do produto: o mesmo
  // produto pode exigir 24 numa tabela e 12 em outra.
  const [textoMinima, setTextoMinima] = useState('')
  const [textoMaxima, setTextoMaxima] = useState('')
  // O preco da unidade SOLTA daquela mesma linha de `precos`. Mora neste bloco,
  // e nao entre os campos do produto, pela mesma razao do preco e da quantidade
  // minima: a mesma coluna muda de valor em cada tabela. Ate 02/09/2026 este
  // campo so existia na tela da TABELA DE PRECO -- a ficha nao tinha onde
  // escrever quanto custa a unidade, e foi a critica dela no celular.
  const [textoAvulso, setTextoAvulso] = useState('')
  const [erroPreco, setErroPreco] = useState<string | null>(null)
  const [erroCodigo, setErroCodigo] = useState<string | null>(null)
  // Decisao dela (D5, 02/09): a ficha ABRE MOSTRANDO. Ate aqui ela abria
  // editavel no primeiro toque, e e a tela do app com mais campos.
  const [modo, setModo] = useState<ModoDaFicha>(modoInicialDaFicha(ehNovo))
  // "Corrigir" do card vermelho da tabela (pedido dela 01/10): abre direto em
  // EDITAR, pinta o que falta, e Salvar/Cancelar voltam para a tabela. Lido uma
  // vez: trocar de aba reescreve o endereco.
  const [corrigir] = useState(() => {
    const params = new URLSearchParams(window.location.search)
    const voltar = ehNovo ? null : voltarDoCorrigir(params)
    return voltar ? { voltar, semComissao: params.get('semComissao') === '1' } : null
  })
  const [abrindoEditando, setAbrindoEditando] = useState(corrigir !== null)
  // As 3 abas (pedido dela, 2o teste real, 03/09): so existem para produto
  // JA SALVO -- "Novo produto" continua na forma unica de sempre, sem abas,
  // porque fiscal e historico nao fazem sentido antes de o produto existir.
  // A aba mora no endereco (?aba=historico) para a ficha reabrir nela ao
  // voltar da tela do cliente. `replace`: trocar de aba nao empilha historico,
  // senao o Voltar passaria aba por aba antes de sair da ficha.
  const [busca, setBusca] = useSearchParams()
  const aba = abaDoEndereco(busca.get('aba'))
  const setAba = (nova: AbaDaFicha) => setBusca(nova === 'comercial' ? {} : { aba: nova }, { replace: true })

  async function aoTrocarModo() {
    const acao = botaoDoModo(modo)
    if (acao.confirma !== null && !(await confirmar(acao.confirma, { botao: 'Descartar', perigo: true }))) return
    if (acao.proximo === 'vendo') {
      // Cancelar volta ao que ESTA SALVO. Os campos do produto voltam sozinhos
      // no proximo render (o `useEffect` copia `existente`); os rascunhos de
      // preco nao tem origem salva -- eles SAO o rascunho --, e por isso zeram
      // aqui.
      setTextoPreco(''); setTextoMinima(''); setTextoMaxima(''); setTextoAvulso('')
      setErroPreco(null); setNomeTabelaNova(null)
    } else {
      // Entrando para editar: o campo comeca com o que JA ESTA gravado nesta
      // tabela, pronto para ajustar -- e nao mais em branco com um aviso do
      // lado (achado dela no 1o teste real no celular, 03/09).
      const rascunho = rascunhoDePrecoAoEditar(precoAtual)
      setTextoPreco(rascunho.preco); setTextoAvulso(rascunho.avulso)
      setTextoMinima(rascunho.minima); setTextoMaxima(rascunho.maxima)
    }
    setModo(acao.proximo)
  }

  // VENDO, a fornecedora vem direto do produto salvo: `campos` so e preenchido
  // pelo efeito um render DEPOIS, e nesse intervalo a ficha piscava "sem preço"
  // e o Adicionar ao pedido apagado (minor 2 da revisao de 23/09). EDITANDO
  // continua vindo de `campos` -- e ali que ela troca a fornecedora.
  const representadaDaFicha =
    modo === 'vendo' && existente ? existente.representada_id : campos.representada_id

  const tabelas = useLiveQuery(
    () =>
      representadaDaFicha === ''
        ? Promise.resolve([] as TabelaPreco[])
        : banco.tabelas_preco
            .where('representada_id').equals(representadaDaFicha)
            .filter((t) => t.ativa && t.apagado_em === null)
            .sortBy('nome'),
    [representadaDaFicha],
  )

  const precosDoProduto = useLiveQuery(
    () => (ehNovo || !id ? Promise.resolve([] as Preco[]) : banco.precos.where('produto_id').equals(id).toArray()),
    [id, ehNovo],
  )

  // Aba Historico (T10, 2o teste real dela, 03/09). `null` = ainda sem
  // fornecedora escolhida (o historico e por representada); `undefined` =
  // ainda carregando -- useLiveQuery devolve undefined ate a 1a resolucao.
  const historico = useLiveQuery(
    () =>
      ehNovo || !id || representadaDaFicha === ''
        ? Promise.resolve(null)
        : historicoDoProduto(id, representadaDaFicha, new Date()),
    [id, ehNovo, representadaDaFicha],
  )

  // Tabela unica ja vem escolhida -- e o caso do representante que tem uma
  // tabela so, e obrigar o clique ali seria so uma forma a mais de esquecer.
  // Derivado, e nao um useEffect que escreve no estado: efeito que preenche
  // campo controlado ja apagou escolha da usuaria neste projeto antes.
  // Vindo do "+ Produto novo" da tabela: fornecedora e tabela FIXAS (spec 2026-09-30).
  const { representadaFixa, tabelaFixa } = origemDoCadastro(ehNovo, new URLSearchParams(window.location.search), tabelas)
  // Revisao final 30/09: um ?tabela= morto ou de outra marca nunca liga o campo.
  const tabelaEfetiva = tabelaEfetivaDoCadastro(tabelaFixa, tabelaEscolhida, tabelas)
  // Categoria/Linha em lista: os valores que ela ja usa (spec 2026-09-30, decisao 6).
  const produtosDaConta = useLiveQuery(() => banco.produtos.toArray(), [])
  // Linha de preco APAGADA nao conta -- mesma regra do estadoDoAdicionar
  // (minor 10 da revisao de 23/09; nada apaga preco hoje, e so coerencia).
  const precoAtual = precosDoProduto?.find(
    (p) => p.tabela_preco_id === tabelaEfetiva && p.apagado_em === null,
  )
  // Achado dela no 1o teste real, 03/09: visualizando, o seletor mostrava
  // TODAS as tabelas da fornecedora, mesmo as que este produto nao tem preco
  // nenhum. Editando continua com a lista cheia -- e por ali que se adiciona
  // o produto a uma tabela nova.
  const tabelasComPreco = tabelasVisiveisNaFicha(tabelas ?? [], precosDoProduto ?? [])
  // O que o campo de preco pode AFIRMAR neste estado. Fora da tela porque a
  // tela nao roda no vitest, e a regra de "quando eu posso mostrar um preco"
  // precisa de teste de verdade -> [precoNoCadastro.ts]
  // Criando tabela nova o campo de preco tambem liga (a tabela nasce no Salvar).
  const tabelaDoCampo = nomeTabelaNova !== null ? NOVA_TABELA : tabelaEfetiva
  const dica = dicaDoPreco(tabelaDoCampo, precoAtual?.preco ?? null)
  // ⚠ `?? null` pelo motivo de sempre: a linha de `precos` em cache no aparelho
  // antes da 0021 nao tem a chave `preco_unidade`, e chega como `undefined`.
  const dicaAvulso = dicaDoAvulso(tabelaDoCampo, precoAtual?.preco_unidade ?? null)
  // Pedido dela 14/10: UND = vendido so por unidade. A ficha mostra apenas o
  // "Valor unitario" (que grava o preco do produto na tabela, o mesmo campo que
  // a embalagem usaria) e nao ha Qtd por Emb nem unidade solta separada.
  const ehUnd = ehUnidadeSolta(campos.unidade)

  // A sugestao do fator e o aviso do minimo, DERIVADOS -- pelo mesmo motivo da
  // `tabelaEfetiva` logo acima: efeito que escreve em campo controlado ja apagou
  // escolha da usuaria neste projeto. A sugestao so aparece com o campo vazio;
  // quem gravar e ela, tocando no botao (decisao dela, 28/08: sugerir o obvio,
  // nunca gravar sozinho).
  const fatorSugerido =
    campos.unidades_por_embalagem.trim() === '' ? sugerirFator(campos.unidade) : null
  // ⚠ `!= null` de proposito: pega null E undefined. O preco salvo no aparelho
  // antes da 0018 nao tem a chave `quantidade_minima`.
  const minimosDosPrecos = (precosDoProduto ?? [])
    .map((p) => p.quantidade_minima)
    .filter((q): q is number => q != null)
  const avisoFator = avisoDeMinimoAoDefinirFator(
    converterFatorEmbalagem(campos.unidades_por_embalagem) ?? null,
    minimosDosPrecos,
  )

  // Revisao final 30/09: so copia o SALVO quando nao esta editando. Editando,
  // gravar o Status mudava `existente` e esta copia apagava o que ja estava
  // digitado; e voltar a 'vendo' (Cancelar ou Salvar) re-copia o salvo -- e
  // isso que faz o Cancelar desfazer de verdade.
  useEffect(() => {
    if (!existente || modo === 'editando') return
    setCampos({
      representada_id: existente.representada_id,
      codigo: existente.codigo,
      descricao: existente.descricao,
      unidade: existente.unidade ?? '',
      categoria: existente.categoria ?? '',
      linha: existente.linha ?? '',
      fabricante: existente.fabricante ?? '',
      // ⚠ `?? ''` pega null E undefined. O produto salvo no aparelho antes da
      // 0020 nao tem a chave, e um `!== null` aqui poria a string "undefined"
      // dentro do campo de texto.
      ncm: existente.ncm ?? '',
      ipi_pct: existente.ipi_pct?.toString() ?? '',
      icms_pct: existente.icms_pct?.toString() ?? '',
      st_pct: existente.st_pct?.toString() ?? '',
      pis_cofins_pct: existente.pis_cofins_pct?.toString() ?? '',
      // Mesmo `?? ''` dos tributos, e pela mesma razao: o produto salvo no
      // aparelho antes da 0021 nao tem a chave, e ela chega como `undefined`.
      unidades_por_embalagem: existente.unidades_por_embalagem?.toString() ?? '',
      foto_url: existente.foto_url ?? '',
      estoque: existente.estoque?.toString() ?? '',
      observacoes: existente.observacoes ?? '',
      ativo: existente.ativo,
    })
  }, [existente, modo])

  async function aoSalvar() {
    // Pedido dela 30/09: codigo repetido na mesma fornecedora nao grava -- o
    // servidor recusaria e o produto ficaria preso em "O que nao subiu".
    const repetido = codigoRepetido(produtosDaConta ?? [], campos.representada_id, campos.codigo, existente?.id)
    if (repetido) {
      const mensagem = `Já existe um produto com o código ${repetido.codigo} nesta fornecedora.`
      setErroCodigo(mensagem)
      throw new Error(mensagem)
    }
    setErroCodigo(null)
    // Tabela nova: validada (nome, comissao padrao) ANTES de gravar qualquer
    // coisa, e gravada antes do produto -- a linha de preco aponta para ela.
    let tabelaNova: { tabelaId: string; gravacoes: Parameters<typeof gravarEmLote>[0] } | null = null
    if (nomeTabelaNova !== null) {
      const tabelasVivas = await banco.tabelas_preco.where('representada_id').equals(representadaDaFicha)
        .filter((t) => t.apagado_em === null).toArray()
      const regraDaFornecedora = await banco.regras_comissao.where('representada_id').equals(representadaDaFicha)
        .filter((r) => r.apagado_em === null && r.tabela_preco_id === null).first()
      const r = gravacoesDeTabelaSoNome({ representadaId: representadaDaFicha, nome: nomeTabelaNova, tabelasVivas, regraDaFornecedora, novo: novoRegistroBase })
      if (!('gravacoes' in r)) {
        const mensagem = r.erroNome ?? r.erroPct ?? 'Não foi possível criar a tabela.'
        setErroPreco(mensagem)
        throw new Error(mensagem)
      }
      tabelaNova = r
    }
    const tabelaParaGravar = tabelaNova?.tabelaId ?? tabelaEfetiva
    // A decisao vem ANTES de gravar o produto de proposito: validando depois, um
    // preco invalido deixaria o produto salvo e o botao dizendo "nao salvou".
    const decisao = decidirPrecoDoCadastro(tabelaParaGravar, textoPreco, textoMinima, textoMaxima)
    // Decisao dela 01/10: criado DENTRO da tabela, o produto sempre entra nela --
    // e no banco so entra com preco (precos.preco e NOT NULL). Sem preco, avisa.
    if (tabelaFixa && decisao.tipo === 'sem_preco') {
      const mensagem = 'Informe o valor da embalagem: o produto entra nesta tabela.'
      setErroPreco(mensagem)
      throw new Error(mensagem)
    }
    if (decisao.tipo === 'erro') {
      setErroPreco(decisao.mensagem)
      // Lancar e o que faz o BotaoSalvar mostrar falha em vez de "✓ Salvo".
      throw new Error(decisao.mensagem)
    }
    // As DUAS decisoes ANTES de gravar qualquer coisa, pela mesma razao que a do
    // preco ja vinha antes do produto: validando depois, um avulso invalido
    // deixaria o produto salvo e o botao dizendo "nao salvou".
    // UND nao tem unidade solta separada: o "Valor unitario" JA e o preco do
    // produto (decisao acima), entao o avulso nunca e gravado nem validado.
    const decisaoAvulso: ReturnType<typeof decidirAvulsoDoCadastro> = ehUnd
      ? { tipo: 'nao_mexer' }
      : decidirAvulsoDoCadastro(
          tabelaParaGravar,
          textoAvulso,
          decisao.tipo === 'gravar',
          precoAtual !== undefined,
        )
    if (decisaoAvulso.tipo === 'erro') {
      setErroPreco(decisaoAvulso.mensagem)
      throw new Error(decisaoAvulso.mensagem)
    }
    setErroPreco(null)

    const registro: Produto = {
      ...(existente ?? novoRegistroBase()),
      representada_id: campos.representada_id,
      codigo: campos.codigo.trim(),
      descricao: campos.descricao.trim(),
      unidade: campos.unidade || null,
      categoria: campos.categoria || null,
      linha: campos.linha || null,
      fabricante: campos.fabricante || null,
      ncm: campos.ncm || null,
      // `converterPercentualTributo` devolve undefined para vazio (o normal) e
      // null para sujeira; o `?? null` achata os dois na coluna anulavel.
      // ⚠ Aqui o achatamento apaga a diferenca DE PROPOSITO: a ficha nao tem
      // tela de erro por campo, e deixar a sujeira passar faria a constraint da
      // 0020 recusar a gravacao com uma mensagem em ingles. Gravar null e o
      // comportamento previsivel -- e o input type="number" com min/max ja barra
      // o grosso antes de chegar aqui.
      ipi_pct: converterPercentualTributo(campos.ipi_pct) ?? null,
      icms_pct: converterPercentualTributo(campos.icms_pct) ?? null,
      st_pct: converterPercentualTributo(campos.st_pct) ?? null,
      pis_cofins_pct: converterPercentualTributo(campos.pis_cofins_pct) ?? null,
      // ⚠ NAO usar `Number(campos.x)` aqui: `Number('')` e 0, e fator 0 e
      // recusado pela trava da 0021 -- a gravacao falharia com erro em ingles.
      // `converterFatorEmbalagem` devolve undefined para vazio e null para
      // sujeira (nao inteiro, zero, negativo); o `?? null` achata os dois, no
      // mesmo molde dos tributos logo acima. Reusar em vez de escrever uma
      // gemea e de proposito: duas leituras do mesmo campo divergem com o tempo.
      // UND nunca tem embalagem fechada: limpa o fator, mesmo que sobre texto no campo escondido.
      unidades_por_embalagem: ehUnd ? null : (converterFatorEmbalagem(campos.unidades_por_embalagem) ?? null),
      foto_url: campos.foto_url || null,
      estoque: campos.estoque === '' ? null : Number(campos.estoque),
      observacoes: campos.observacoes || null,
      ativo: campos.ativo,
    }
    if (tabelaNova) await gravarEmLote(tabelaNova.gravacoes)
    await gravarLocalEEnfileirar('produtos', registro)

    // O preco depois do produto: a linha de `precos` aponta para ele, e a fila
    // sobe na ordem em que entrou.
    if (decisao.tipo === 'gravar' || decisaoAvulso.tipo === 'gravar') {
      const existente = precosDoProduto?.find((p) => p.tabela_preco_id === tabelaParaGravar)
      // O literal tem NOME para a guarda de contrato poder recortar exatamente o
      // que e gravado -- mesmo molde de `embalagem.contrato.test.ts`. O que nao
      // estiver aqui dentro NAO e gravado, e nada avisa.
      const linhaDePreco = {
        ...(existente ?? {
          ...novoRegistroBase(),
          tabela_preco_id: tabelaParaGravar,
          produto_id: registro.id,
        }),
        // ⚠ As chaves so entram quando HA decisao de gravar. Sem esta guarda,
        // salvar so o avulso apagaria o preco da caixa, e salvar so o preco
        // apagaria o avulso que ja estava gravado.
        ...(decisao.tipo === 'gravar'
          ? {
              preco: decisao.preco,
              quantidade_minima: decisao.minima,
              quantidade_maxima: decisao.maxima,
            }
          : {}),
        ...(decisaoAvulso.tipo === 'gravar' ? { preco_unidade: decisaoAvulso.avulso } : {}),
      }
      await gravarLocalEEnfileirar('precos', linhaDePreco)
    }

    // Ao CRIAR, volta para a lista, como antes. Ao EDITAR, volta para a
    // VISUALIZACAO -- pedido dela no 1o teste real: conferir sem risco de
    // editar de novo sem querer, e um toque em "Editar" resolve se precisar
    // consertar outra coisa.
    // Com preco na tabela de onde veio, volta em "Nesta tabela" (teste dela 01/10).
    const entrouNaTabela = decisao.tipo === 'gravar' && tabelaParaGravar === tabelaFixa?.id
    if (ehNovo) navegar(destinoAoCriarProduto(new URLSearchParams(window.location.search), registro.id, entrouNaTabela), { replace: true })
    else if (corrigir) navegar(corrigir.voltar, { replace: true })
    else {
      setTextoPreco(''); setTextoMinima(''); setTextoMaxima(''); setTextoAvulso('')
      setModo('vendo')
      if (tabelaNova) { setTabelaEscolhida(tabelaNova.tabelaId); setNomeTabelaNova(null) }
    }
  }

  // Abre EDITANDO so com o produto e os precos carregados: o rascunho do preco
  // vem da linha gravada na tabela de onde veio, igual ao toque em "Editar".
  // ⚠ Pela tabela do ENDERECO, e nao pela `precoAtual`: a lista de tabelas
  // chega vazia antes do produto, e o preco gravado abriria em branco.
  useEffect(() => {
    if (!abrindoEditando || !existente || precosDoProduto === undefined) return
    const rascunho = rascunhoDePrecoAoEditar(
      precosDoProduto.find((p) => p.tabela_preco_id === tabelaEscolhida && p.apagado_em === null),
    )
    setTextoPreco(rascunho.preco); setTextoAvulso(rascunho.avulso)
    setTextoMinima(rascunho.minima); setTextoMaxima(rascunho.maxima)
    setModo('editando')
    setAbrindoEditando(false)
  }, [abrindoEditando, existente, precosDoProduto, tabelaEscolhida])

  // Achado dela no 2o teste real, 03/09: tirando o botao Cancelar do
  // cabecalho, a seta ao lado do "CRM Multimarca" (que mora no Layout, fora
  // desta tela) virou a UNICA saida de quem esta editando -- e sem isto ela
  // sairia calada, sem a mesma pergunta que o Cancelar fazia.
  useEffect(() => {
    if (modo !== 'editando') return
    return registrarGuardaDeSaida(() => confirmar(botaoDoModo('editando').confirma!, { botao: 'Descartar', perigo: true }))
  }, [modo])

  // Mesmo funil do card da lista (acaoDoCard, T2 de 03/09): a pergunta diz o
  // NOME do produto e a CONSEQUENCIA, e grava so o `ativo` -- inativar e sobre
  // vender daqui pra frente, nao mexe em preco nem em pedido ja feito.
  async function aoAlternarAtivo() {
    if (!existente) return
    const acao = acaoDoCard(existente)
    if (!(await confirmar(acao.pergunta, { botao: acao.rotulo }))) return
    const registroDoCard = { ...existente, ativo: acao.novoAtivo }
    await gravarLocalEEnfileirar('produtos', registroDoCard)
    // Editando, o efeito nao re-copia o salvo: o Status muda so aqui.
    setCampos((c) => ({ ...c, ativo: acao.novoAtivo }))
  }

  // Cancelar (decisao dela 30/09): NOVO so pergunta se mexeu em algo; EDITANDO
  // volta para a ficha de VER pelo mesmo caminho de sempre (aoTrocarModo pergunta).
  const [camposIniciais] = useState(() => JSON.stringify(campos))
  async function aoCancelar() {
    if (!ehNovo && corrigir) {
      if (!(await confirmar(botaoDoModo('editando').confirma!, { botao: 'Descartar', perigo: true }))) return
      return navegar(corrigir.voltar, { replace: true })
    }
    if (!ehNovo) return aoTrocarModo()
    const sujo = JSON.stringify(campos) !== camposIniciais || [textoPreco, textoAvulso, textoMinima, textoMaxima].some((t) => t !== '')
    if (sujo && !(await confirmar(botaoDoModo('editando').confirma!, { botao: 'Descartar', perigo: true }))) return
    navegar(-1)
  }

  async function aoExcluir() {
    if (!id) return
    if (!(await confirmar('Excluir este produto?', { botao: 'Excluir', perigo: true }))) return
    await apagarLocalEEnfileirar('produtos', id)
    navegar('/produtos', { replace: true })
  }

  // Modo de VER da ficha nova (spec 2026-09-23). O modo de EDITAR e o "Novo
  // produto" continuam no JSX de baixo, sem mudanca nenhuma.
  if (!ehNovo && modo === 'vendo' && existente && !abrindoEditando) {
    return (
      <FichaProdutoVendo
        produto={existente}
        representada={representadas?.find((r) => r.id === existente.representada_id)}
        aba={aba} aoTrocarAba={setAba}
        aoEditar={() => void aoTrocarModo()} aoAlternarAtivo={() => void aoAlternarAtivo()}
        tabelasComPreco={tabelasComPreco} tabelaEfetiva={tabelaEfetiva}
        aoEscolherTabela={setTabelaEscolhida} precoAtual={precoAtual}
        precosDoProduto={precosDoProduto ?? []} tabelas={tabelas ?? []}
        historico={historico}
      />
    )
  }

  // Procurou e nao existe: link velho, ou o produto foi apagado (inclusive em
  // outro aparelho, enquanto ela olhava).
  if (!ehNovo && existente === null) {
    return (
      <section className="p-4 space-y-3">
        <p className="text-slate-700 font-semibold">Produto não encontrado</p>
        <p className="text-sm text-slate-500">Ele pode ter sido excluído.</p>
        <button
          type="button" onClick={() => navegar('/produtos', { replace: true })}
          className="rounded-lg bg-teal-700 text-white px-4 py-2 text-sm font-semibold"
        >
          Voltar para Produtos
        </button>
      </section>
    )
  }

  // Produto ainda carregando do banco local: a ficha nova so desenha com ele
  // na mao, e o formulario de edicao nao e a tela certa para piscar enquanto isso.
  if (!ehNovo && modo === 'vendo') return <p className="p-4 text-sm text-slate-500">Carregando…</p>

  const estiloCampo = 'w-full min-w-0 border border-slate-300 rounded-lg px-3 py-2 bg-white'
  // Vindo do "Corrigir": o que falta fica VERMELHO, e some ao digitar.
  const faltas = corrigir && faltasNoCadastro({
    unidade: campos.unidade, qtd: campos.unidades_por_embalagem, preco: textoPreco, semComissao: corrigir.semComissao,
  })
  const estiloFalta = 'w-full min-w-0 border-2 border-red-500 rounded-lg px-3 py-2 bg-red-50'
  const estiloRotulo = 'block text-sm text-slate-600 mb-1'
  const nomeFornecedoraFixa = representadas?.find((r) => r.id === representadaFixa)?.nome ?? ''
  const mudar = (campo: keyof typeof campos) => (e: { target: { value: string } }) =>
    setCampos((c) => ({ ...c, [campo]: e.target.value }))

  // Formulario em SECOES (spec 2026-09-30, tela Novo/Editar produto ciclo 1):
  // uma pagina so, sem as abas no modo editando; a ficha de VER (acima) nao muda.
  return (
    <section className="p-4 pb-40 space-y-4">
      <div>
        <h2 className="text-2xl font-bold text-slate-800">{ehNovo ? 'Novo produto' : 'Editar produto'}</h2>
        <p className="text-sm text-slate-500">
          {tabelaFixa
            ? `${nomeFornecedoraFixa} · Tabela ${tabelaFixa.nome}`
            : 'Cadastre os dados do produto para utilizar nos seus pedidos.'}
        </p>
        {faltas?.comissao && (
          <p className="mt-2 rounded-lg border border-red-300 bg-red-50 px-3 py-2 text-sm text-red-700">
            Falta a comissão: ela se preenche no card da tabela, campo Comissão (%).
          </p>
        )}
      </div>
      <form
        onSubmit={(e) => { e.preventDefault(); void executar(aoSalvar) }}
        className="space-y-4"
      >
        <div className="bg-white rounded-xl shadow-sm p-4 space-y-3">
          <div className="flex gap-3">
            <CaixaFoto url={campos.foto_url} aoTocar={() => document.getElementById('foto')?.focus()} />
            <div className="min-w-0 flex-1 space-y-3">
              {/* Vindo da tabela a fornecedora e FIXA (decisao dela 30/09): o
                  nome ja esta no subtitulo, e trocar gravaria na tabela errada. */}
              {!representadaFixa && (
                <div>
                  <label htmlFor="rep" className={estiloRotulo}>Fornecedora</label>
                  <div className="flex gap-2">
                    <select
                      id="rep" required value={campos.representada_id}
                      onChange={(e) => {
                        setCampos((c) => ({ ...c, representada_id: e.target.value }))
                        // Tabela de outra marca nao serve para este produto -- nem o
                        // rascunho de preco dela (revisao final 30/09: com tabela unica
                        // na marca nova, o preco da antiga seria gravado la).
                        setTabelaEscolhida(''); setNomeTabelaNova(null)
                        setTextoPreco(''); setTextoAvulso(''); setTextoMinima(''); setTextoMaxima('')
                        setErroPreco(null)
                      }}
                      className={estiloCampo}
                    >
                      <option value="">Selecione…</option>
                      {representadas?.map((r) => (
                        <option key={r.id} value={r.id}>{r.nome}</option>
                      ))}
                    </select>
                    {ehNovo && (
                      // Sem a palavra "fornecedora" no nome acessivel: getByLabel
                      // ('Fornecedora') acharia os dois (licao nome-acessivel).
                      <Link to="/representadas/nova" aria-label="Adicionar nova"
                        className="shrink-0 w-10 rounded-lg bg-teal-700 text-white text-xl flex items-center justify-center">+</Link>
                    )}
                  </div>
                </div>
              )}
              <div className="grid grid-cols-2 gap-2">
                <div className="min-w-0">
                  <label htmlFor="codigo" className={estiloRotulo}>Código</label>
                  <input id="codigo" required placeholder="Ex.: 12345" value={campos.codigo}
                    onChange={(e) => { setCampos((c) => ({ ...c, codigo: e.target.value })); setErroCodigo(null) }} className={estiloCampo} />
                </div>
                <div className="min-w-0">
                  <span className={estiloRotulo}>Status</span>
                  {/* Um so controle de ativo por vez: NOVO grava no Salvar;
                      EDITANDO grava na hora com a pergunta de sempre
                      (aoAlternarAtivo) -- dois gravariam valores diferentes. */}
                  <button
                    type="button" role="switch" aria-checked={campos.ativo} aria-label="Status"
                    onClick={ehNovo ? () => setCampos((c) => ({ ...c, ativo: !c.ativo })) : () => void aoAlternarAtivo()}
                    className="w-full flex items-center gap-2 border border-slate-300 rounded-lg px-2 py-2"
                  >
                    <span className={`relative w-9 h-5 rounded-full shrink-0 ${campos.ativo ? 'bg-emerald-500' : 'bg-slate-300'}`}>
                      <span className={`absolute top-0.5 w-4 h-4 rounded-full bg-white shadow ${campos.ativo ? 'left-4' : 'left-0.5'}`} />
                    </span>
                    <span className="text-sm">{campos.ativo ? 'Ativo' : 'Inativo'}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          {erroCodigo && <p className="text-sm text-red-600" role="alert">{erroCodigo}</p>}
          <div>
            <label htmlFor="desc" className={estiloRotulo}>Descrição do produto</label>
            <input id="desc" required placeholder="Digite a descrição completa do produto" value={campos.descricao}
              onChange={mudar('descricao')} className={estiloCampo} />
          </div>
        </div>

        <Secao titulo="Classificação" icone={<IconeEtiqueta />}>
          <div className="grid grid-cols-2 gap-3">
            <CampoLista id="cat" rotulo="Categoria" valor={campos.categoria} textoNova="+ Nova categoria…"
              opcoes={valoresUsados(produtosDaConta ?? [], 'categoria', campos.categoria)}
              aoMudar={(v) => setCampos((c) => ({ ...c, categoria: v }))} />
            <CampoLista id="linha" rotulo="Linha" valor={campos.linha} textoNova="+ Nova linha…"
              opcoes={valoresUsados(produtosDaConta ?? [], 'linha', campos.linha)}
              aoMudar={(v) => setCampos((c) => ({ ...c, linha: v }))} />
          </div>
          <div>
            <label htmlFor="fabricante" className={estiloRotulo}>Fabricante</label>
            <input id="fabricante" placeholder="Ex.: MAURI" value={campos.fabricante} onChange={mudar('fabricante')} className={estiloCampo} />
          </div>
        </Secao>

        <Secao titulo="Embalagem e preço" icone={<IconeCaixa />}>
          {campos.representada_id === '' ? (
            <p className="text-sm text-slate-500">Escolha a fornecedora para informar o preço.</p>
          ) : (
            <>
              {!tabelaFixa && nomeTabelaNova !== null && (
                <div>
                  <label htmlFor="tabela-nova" className={estiloRotulo}>Nome da tabela nova</label>
                  <div className="flex gap-1">
                    <input id="tabela-nova" autoFocus value={nomeTabelaNova} placeholder="Ex.: Maringá"
                      onChange={(e) => { setNomeTabelaNova(e.target.value); setErroPreco(null) }} className={estiloCampo} />
                    <button type="button" aria-label="Voltar para a lista de tabelas"
                      onClick={() => { setNomeTabelaNova(null); setErroPreco(null) }} className="shrink-0 px-2 text-teal-800 text-sm">Lista</button>
                  </div>
                  <p className="text-xs text-slate-500 mt-1">Criada ao salvar, com a comissão padrão da fornecedora. Ajuste depois em Editar tabela.</p>
                </div>
              )}
              {!tabelaFixa && nomeTabelaNova === null && (
                <div>
                  <label htmlFor="tabela-preco" className={estiloRotulo}>Tabela de preço</label>
                  <select
                    id="tabela-preco" value={tabelaEfetiva}
                    onChange={(e) => {
                      const novaTabela = e.target.value
                      if (novaTabela === NOVA_TABELA) {
                        setNomeTabelaNova(''); setTabelaEscolhida(''); setErroPreco(null)
                        setTextoPreco(''); setTextoAvulso(''); setTextoMinima(''); setTextoMaxima('')
                        return
                      }
                      setTabelaEscolhida(novaTabela)
                      setErroPreco(null)
                      // Troca de tabela EDITANDO tambem re-preenche o rascunho
                      // com o que ja esta gravado naquela tabela -- sem isto,
                      // o campo continuaria mostrando o preco da tabela
                      // anterior, ou um rascunho digitado para ela.
                      const linha = precosDoProduto?.find((p) => p.tabela_preco_id === novaTabela)
                      const rascunho = rascunhoDePrecoAoEditar(linha)
                      setTextoPreco(rascunho.preco); setTextoAvulso(rascunho.avulso)
                      setTextoMinima(rascunho.minima); setTextoMaxima(rascunho.maxima)
                    }}
                    className={estiloCampo}
                  >
                    <option value="">Selecione…</option>
                    {tabelas?.map((t) => (
                      <option key={t.id} value={t.id}>{t.nome}</option>
                    ))}
                    <option value={NOVA_TABELA}>+ Nova tabela…</option>
                  </select>
                </div>
              )}
              {/* Embalagem: SELETOR FECHADO (CX/FD/KG), 3o teste real de 03/09;
                  desde 30/09 aparece LOGO, sem esperar a quantidade. Produto que
                  ja tem "dz", "saco" ou "balde" fica de fora do fechado: o valor
                  gravado vira uma opcao extra, e NUNCA se reescreve sozinho --
                  ver produtos/seletorEmbalagem.ts. */}
              <div className="grid grid-cols-2 gap-3">
                <div className="min-w-0">
                  <label htmlFor="unidade" className={estiloRotulo}>Tipo de embalagem</label>
                  <select id="unidade" value={valorNoSeletor(campos.unidade)} onChange={mudar('unidade')} className={faltas?.tipo ? estiloFalta : estiloCampo}>
                    <option value="">Selecione…</option>
                    {OPCOES_EMBALAGEM_FECHADA.map((o) => (
                      <option key={o.valor} value={o.valor}>{o.rotulo}</option>
                    ))}
                    {ehValorLegado(campos.unidade) && (
                      <option value={campos.unidade}>{campos.unidade}</option>
                    )}
                  </select>
                </div>
                {!ehUnd && (
                  <div className="min-w-0">
                    <label htmlFor="unidades_por_embalagem" className={estiloRotulo}>Qtd por Emb</label>
                    <input id="unidades_por_embalagem" type="number" min="1" step="1" inputMode="numeric"
                      aria-label="Unidades por embalagem"
                      placeholder={fatorSugerido === null ? 'Ex.: 12' : String(fatorSugerido)}
                      value={campos.unidades_por_embalagem} onChange={mudar('unidades_por_embalagem')} className={faltas?.qtd ? estiloFalta : estiloCampo} />
                  </div>
                )}
              </div>
              {faltas?.tipo && <p className="text-xs text-red-700">Informe o tipo de embalagem.</p>}
              {faltas?.qtd && <p className="text-xs text-red-700">Produto em {campos.unidade.trim().toUpperCase().replace(/\.$/, '')}: informe a Qtd por embalagem.</p>}
              {!ehUnd && fatorSugerido !== null && (
                <button type="button" className="text-sm text-sky-700 underline py-1"
                  onClick={() =>
                    setCampos((c) => ({ ...c, unidades_por_embalagem: String(fatorSugerido) }))}>
                  usar {fatorSugerido}
                </button>
              )}
              {!ehUnd && avisoFator !== null && (
                <p className="text-xs text-amber-700 bg-amber-50 rounded px-2 py-1">{avisoFator}</p>
              )}
              {ehUnd ? (
                /* UND: um campo so. E o preco do produto na tabela (o mesmo
                   `textoPreco` da embalagem); nao existe unidade solta separada. */
                <div className="min-w-0">
                  <label htmlFor="preco" className={estiloRotulo}>{ROTULO_PRECO_AVULSO}</label>
                  <CampoMoeda
                    id="preco" value={textoPreco}
                    onChange={(texto) => { setTextoPreco(texto); setErroPreco(null) }}
                    className={faltas?.preco ? estiloFalta : estiloCampo}
                    placeholder={dica.exemplo}
                    disabled={!dica.campoLigado}
                  />
                </div>
              ) : (
              <>
              <div className="grid grid-cols-2 gap-3">
                <div className="min-w-0">
                  <label htmlFor="preco" className={estiloRotulo}>
                    Valor emb{campos.unidade ? ` (${campos.unidade})` : ''}
                  </label>
                  <CampoMoeda
                    id="preco" value={textoPreco}
                    onChange={(texto) => { setTextoPreco(texto); setErroPreco(null) }}
                    className={faltas?.preco ? estiloFalta : estiloCampo}
                    // Sem tabela escolhida o campo fica inerte e SEM o "0,00":
                    // numero de exemplo dentro de um campo rotulado "Preço" nao
                    // se le como exemplo, le-se como preco -- foi assim que a
                    // ficha do 568 pareceu custar zero enquanto o card dizia
                    // R$ 22,50.
                    placeholder={dica.exemplo}
                    disabled={!dica.campoLigado}
                  />
                </div>
                <div className="min-w-0">
                  <label htmlFor="preco-avulso" className={estiloRotulo}>{ROTULO_PRECO_AVULSO}</label>
                  {/* CampoMoeda, e nao type="number": o campo numerico do
                      navegador engole o ponto de milhar ("1.234,56" vira
                      R$ 1,23, sem erro e sem aviso). Ha guarda de contrato dos
                      campos de dinheiro prendendo isso. */}
                  <CampoMoeda
                    id="preco-avulso" value={textoAvulso}
                    onChange={(texto) => { setTextoAvulso(texto); setErroPreco(null) }}
                    className={estiloCampo}
                    // Vazio de proposito, e nao "0,00": aqui o zero e uma
                    // RESPOSTA ("nao vende avulso"), entao oferece-lo como
                    // exemplo ensinaria a resposta errada -- ver dicaDoAvulso.
                    placeholder={dicaAvulso.exemplo}
                    disabled={!dicaAvulso.campoLigado}
                  />
                </div>
              </div>
              </>
              )}
              {faltas?.preco && <p className="text-xs text-red-700">{ehUnd ? 'Informe o valor unitário nesta tabela.' : 'Informe o valor da embalagem nesta tabela.'}</p>}
              {!ehUnd && (
                <p className="text-xs text-slate-500">
                  Valor unitário: vem da tabela quando ela já tem; sem valor na tabela, começa em 0 e dá
                  para editar. Em branco = mantém o que já existe.
                </p>
              )}
              <div className="rounded-lg bg-teal-50/60 p-3 space-y-3">
                <p className="flex items-center gap-2 text-sm font-semibold text-teal-900"><IconeGrafico tamanho={16} />Limites de venda</p>
                {/* type="number" aqui esta CERTO, e a guarda de contrato dos
                    campos de dinheiro tem as duas excecoes declaradas: isto e
                    numero de CONTAR, nao dinheiro. Nao ha ponto de milhar para
                    o navegador engolir, e o teclado so de digitos ajuda. */}
                <div className="grid grid-cols-2 gap-3">
                  <div className="min-w-0">
                    <label htmlFor="quantidade-minima" className={estiloRotulo}>
                      Quant. mínima
                      {tabelaEfetiva !== '' && precoAtual?.quantidade_minima != null && (
                        ` — atual: ${precoAtual.quantidade_minima}`
                      )}
                    </label>
                    <input
                      id="quantidade-minima" type="number" min="0" step="0.001"
                      placeholder="sem mínimo" value={textoMinima}
                      onChange={(e) => { setTextoMinima(e.target.value); setErroPreco(null) }}
                      className={estiloCampo}
                    />
                  </div>
                  <div className="min-w-0">
                    <label htmlFor="quantidade-maxima" className={estiloRotulo}>
                      Quant. máxima
                      {tabelaEfetiva !== '' && precoAtual?.quantidade_maxima != null && (
                        ` — atual: ${precoAtual.quantidade_maxima}`
                      )}
                    </label>
                    <input
                      id="quantidade-maxima" type="number" min="0" step="0.001"
                      placeholder="sem máximo" value={textoMaxima}
                      onChange={(e) => { setTextoMaxima(e.target.value); setErroPreco(null) }}
                      className={estiloCampo}
                    />
                  </div>
                </div>
                <p className="text-xs text-sky-800 bg-sky-50 rounded-lg px-3 py-2">
                  Em branco = este preço vale para qualquer quantidade.
                </p>
              </div>
            </>
          )}
          {/* Fora dos ramos de proposito: sem tabela, o erro sumia junto com o bloco (e2e 30/09). */}
          {erroPreco && (
            <p className="text-sm text-red-600" role="alert">{erroPreco}</p>
          )}
        </Secao>

        <Secao titulo="Estoque e imagem" icone={<IconePredio />}>
          <div className="grid grid-cols-2 gap-3">
            <div className="min-w-0">
              <label htmlFor="estoque" className={estiloRotulo}>Estoque atual</label>
              <input id="estoque" type="number" step="0.001" placeholder="Ex.: 0" value={campos.estoque}
                onChange={mudar('estoque')} className={estiloCampo} />
            </div>
            <div className="min-w-0">
              <label htmlFor="foto" className={estiloRotulo}>Foto (URL opcional)</label>
              <input id="foto" placeholder="https://…" value={campos.foto_url} onChange={mudar('foto_url')} className={estiloCampo} />
            </div>
          </div>
        </Secao>

        {/* 3 por linha (spec 2026-09-30): NCM | IPI | ICMS / ST | PIS/COFINS. */}
        <Secao titulo="Dados fiscais" icone={<IconeDocumento />}>
          <div className="grid grid-cols-3 gap-2">
            <div className="min-w-0">
              <label htmlFor="ncm" className={estiloRotulo}>NCM</label>
              <input id="ncm" placeholder="Ex.: 19051000" value={campos.ncm} onChange={mudar('ncm')} className={estiloCampo} />
            </div>
            <div className="min-w-0">
              <label htmlFor="ipi" className={estiloRotulo}>IPI %</label>
              <input id="ipi" type="number" step="0.01" min="0" max="100" placeholder="0,00" value={campos.ipi_pct}
                onChange={mudar('ipi_pct')} className={estiloCampo} />
            </div>
            <div className="min-w-0">
              <label htmlFor="icms" className={estiloRotulo}>ICMS %</label>
              <input id="icms" type="number" step="0.01" min="0" max="100" placeholder="0,00" value={campos.icms_pct}
                onChange={mudar('icms_pct')} className={estiloCampo} />
            </div>
            <div className="min-w-0">
              <label htmlFor="st" className={estiloRotulo}>ST %</label>
              <input id="st" type="number" step="0.01" min="0" max="100" placeholder="0,00" value={campos.st_pct}
                onChange={mudar('st_pct')} className={estiloCampo} />
            </div>
            <div className="min-w-0 col-span-2">
              <label htmlFor="pis-cofins" className={estiloRotulo}>PIS/COFINS %</label>
              <input id="pis-cofins" type="number" step="0.01" min="0" max="100" placeholder="0,00" value={campos.pis_cofins_pct}
                onChange={mudar('pis_cofins_pct')} className={estiloCampo} />
            </div>
          </div>
        </Secao>

        <Secao titulo="Observações" icone={<IconeLapis />}>
          <textarea id="obs" aria-label="Observações" rows={3} value={campos.observacoes}
            onChange={mudar('observacoes')} className={estiloCampo} />
        </Secao>

        <BarraSalvar aoCancelar={() => void aoCancelar()} estado={estadoSalvamento} />
      </form>
      {/* Excluir so aparece EDITANDO, discreto e FORA da barra fixa (decisao
          dela 30/09): e o botao mais caro da tela. */}
      {!ehNovo && (
        <button onClick={() => void aoExcluir()} className="w-full text-red-600 text-sm underline py-2">
          Excluir produto
        </button>
      )}
    </section>
  )
}
